import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a product's SKU based on the selected variant.
 * This component listens for variant update events and updates the SKU display accordingly.
 */
class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /**
   * Updates the SKU display when a variant is selected.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSku = (event) => {
    // Check if this update is for the correct product
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the updated SKU element in the new HTML
    const newSku = event.detail.data.html.querySelector('product-sku');
    
    if (!newSku) return;

    // Use morph to update the content, just like product-price and product-inventory
    morph(this, newSku, { childrenOnly: true });
  };
}

// Register the custom element
if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}

export default ProductSku;